import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import RetailCreate from './index';

const RetailCreateRouteWrapper = () => {
  const { tradeId } = useParams();
  const history = useHistory();

  const handleClose = () => {
    history.goBack();
  };
  return (
    <RetailCreate isOmp={false} tradeId={tradeId} handleClose={handleClose} />
  );
};

export default RetailCreateRouteWrapper;
